import * as _ from 'lodash-es'

export class GengineSettings {
  username : string = Math.random().toString();
  serverUrl: string = "ws://gengine.sourcepaint.cz";
  world?: string| null;
  autoConnect: boolean = false;

  constructor() {
    this.save = _.throttle(this.save.bind(this),500);
  }

  load() {
    const data = JSON.parse(localStorage.getItem('gengineSettings') || "{}");
    Object.assign(this, data);
  }

  save() {
    const clone = _.clone(this);
    localStorage.setItem('gengineSettings', JSON.stringify(clone));
  }

}
